import "./Footer.css";

const Footer = () => {
    return (
        <footer>
            <p>
                2026 &copy; MIT.{" "}
                <a href="https://accessibility.mit.edu/" target="_blank" rel="noopener noreferrer">
                    Learn about MIT's commitment to accessibility.
                </a>
            </p>
            <p className="disclaimer">
                Disclaimer: The information presented on this site is for educational purposes only and does not constitute legal advice. Neither MIT, MIT CSHub, nor their employees and students make any representations or warranties, express or implied, with respect to the use of or reliance on the data provided herewith, regardless of its format or means of transmission. There are no guarantees or representations to the user as to the accuracy, currency, completeness, suitability or reliability of this data for any purpose. THE USER ACCEPTS THE DATA 'AS IS' AND ASSUMES ALL RISKS ASSOCIATED WITH ITS USE. MIT assumes no responsibility for actual, consequential, incidental, special or exemplary damages resulting from, caused by or associated with any user's reliance on or use of this data, even if appraised of the likelihood of such damages occurring.
            </p>
        </footer>
    );
};

export default Footer;
